import React from 'react'
import { FileText } from 'lucide-react'
import GenericTable from '../../components/GenericTable'

const AdminDocuments = () => {
  return (
    <GenericTable
      tableName="documents"
      title="Documents"
      icon={FileText}
      iconColor="indigo"
      searchFields={['document_name', 'document_type', 'file_path', 'document_number']}
      hiddenFields={['document_id', 'created_at', 'updated_at']}
      primaryKey="document_id"
      defaultFields={['document_number', 'document_name', 'document_type', 'status', 'upload_date', 'customer_name', 'verification_status']}
      addFields={['customer_id', 'document_name', 'document_type', 'file_path', 'status']}
      editFields={[
        'document_name', 'document_type', 'file_path', 'status', 'description',
        'expiry_date', 'verification_status', 'uploaded_by'
        // Excluded: document_id, document_number, created_at, updated_at
      ]}
    />
  )
}

export default AdminDocuments
